import * as userService from "./user";
import * as storeService from "./store";
import * as roleService from "./role";
import * as productService from "./product";
import * as categoryService from "./category";
import * as serviceService from "./service";
import * as providerService from "./provider";
import * as customerService from "./customer";
import * as employeeService from "./employee";
import * as sellService from "./sell";
import * as reportService from "./report";
import * as notificationService from "./notification";
import * as dashboardService from "./dashboard";
import * as offerService from "./offer";
import * as quotationService from "./quotation";
import * as documentTypeService from "./documentType";
import * as rewardService from "./reward";
import * as newsletterService from "./newsletter";
import * as contactUsService from "./contact-us";
import * as franchiseService from "./franchise";

export {
  userService,
  storeService,
  roleService,
  productService,
  categoryService,
  serviceService,
  providerService,
  customerService,
  employeeService,
  sellService,
  reportService,
  notificationService,
  dashboardService,
  offerService,
  quotationService,
  documentTypeService,
  rewardService,
  newsletterService,
  contactUsService,
  franchiseService
};



// WEBPACK FOOTER //
// ./src/service/index.js